define('constants/marketingIndustryEnumerations',[], function() {
    return {
        Accounting: 49,
        Architecture: 2,
        Arts: 3,
        Automotive: 50,
        Beauty: 4,
        Camping: 51,
        Chiropractors: 67,
        Cleaning: 52,
        Construction: 7,
        Consulting: 8,
        Dental: 53,
        Education: 12,
        Electrical: 54,
        Financial: 47,
        Flooring: 55,
        FuneralHome: 56,
        GeneralContracting: 57,
        Health: 17,
        Home: 19,
        Hospitality: 59,
        HumanResources: 60,
        Hvac: 58,
        Insurance: 20,
        Internet: 61,
        Landscaping: 62,
        Legal: 21,
        Manufacturing: 22,
        Marketing: 23,
        Media: 24,
        Medical: 25,
        Non: 28,
        Other: 45,
        PersonalCare: 63,
        Plumbing: 64,
        Real: 34,
        Religion: 36,
        Restaurant: 37,
        Retail: 38,
        Roofing: 65,
        Sports: 41,
        Telecommunications: 42,
        Transportation: 66,
        Travel: 43,
    };
});
